module.exports = __webpack_public_path__ + "img/img3.9cc726f4.png";